import React from 'react';

const InputField = ({ label, name, type, value, onChange, placeholder, error, required }) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label} {required && <span className="required">*</span>}</label>
      <input
        id={name}
        type={type || 'text'}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={error ? 'error' : ''}
      />
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

export default InputField; 